import styled from 'styled-components';
import { theme } from "../../theme";
export var TabSlider = styled.div.withConfig({
  displayName: "TabSlider",
  componentId: "vapor__k2b7cs-0"
})(["position:absolute;border-radius:", ";background:", ";height:100%;transition:transform 150ms ", ";"], theme.spaces[8], theme.colors.background.interactive.activated, theme.transitions.eases.primary);